var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expand-transition',[_c('v-alert',{attrs:{"colored-border":"","border":"left","color":_vm.color,"icon":_vm.icon,"dismissible":"","elevation":"5"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.messageShort)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }